import { ref } from 'vue';
import { useEnvVariables } from '@/composables/useEnvVariables';
import { z } from 'zod';



const NotificationCountAPIResponseSchema = z.object({
  expectedActionCounter: z.number(),
  dueTasks: z.number(),
  newNews: z.number(),
});

type NotificationCountAPIResponse = z.infer<typeof NotificationCountAPIResponseSchema>;

type APIResult = [Error, null] | [null, NotificationCountAPIResponse];

const actions = ref(0);
const task = ref(0);
const news = ref(0);

export function useNotification() {
  const getNotificationCount = async () => {
    const [error, data] = await getNotificationCountAPI();
    
    if (error) {
      console.error('Erreur lors de la récupération des notifications :', error);
      return;
    }

    actions.value = data.expectedActionCounter;
    task.value = data.dueTasks;
    news.value = data.newNews;
  };

  const getNotificationCountAPI = async (): Promise<APIResult> => {
    try {
      const { environmentVariables } = useEnvVariables();
      const response = await fetch(`${window.location.origin}${environmentVariables.basePath.value}/perimetre/quickAccessCounters`);
      
      if (!response.ok) {
        return [new Error(`HTTP error! status: ${response.status}`), null];
      }

      const dataResponse = await response.json();
      const data = NotificationCountAPIResponseSchema.parse(dataResponse);

      return [null, data];
    } catch (err) {
      return [err as Error, null];
    }
  };

  return { getNotificationCount, actions, task, news };
}
